<template>
  <div class="index">
    <!-- 筛选 -->
    <section v-if="userInfo.organization">
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <el-form-item label="身份证：">
            <el-input clearable v-model="filterForm.u_idCard" placeholder="请输入身份证"></el-input>
          </el-form-item>
          <el-form-item label="起始时间">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.startSalaryMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="截止时间">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.endSalaryMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item>
        </div>
        <!-- <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="searchHandler" />
        </div> -->
        <div class="filter-btn">
          <el-button type="primary" @click="pageData.currentPage=1,searchHandler()" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="setKeywordHandler" v-if="userInfo.organization">配置参数</el-button>
      <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <!-- <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">创建</el-button> -->
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify&&userInfo.organization" :disabled="selectRows.length!==1">编辑</el-button>
      <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import&&userInfo.organization">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload>
      <!-- <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button> -->
      <!-- <el-button type="success" icon="el-icon-download" @click="exportHandler()" v-if="btnShow.export">数据导出</el-button> -->
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete&&userInfo.organization">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      dialogWidth="1000px"
      :dialogTitle="dialogTitle"
      :formItems="formItems"
      :formItems2="formItems2" />

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      dialogWidth="1000px"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @submitHandler="editSubmitHandler" />

    <el-dialog
      title="导入提示"
      :close-on-click-modal="false"
      :visible.sync="isShowImportTip"
      :append-to-body="true"
      width="500px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>

    <el-dialog
      title="配置参数"
      :close-on-click-modal="false"
      :visible.sync="isShowSetkeyword"
      :append-to-body="true"
      width="500px">
      <el-form :model="keywordData" label-width="120px">
        <el-form-item label="身份证参数">
          <el-input clearable size="mini" style="width:320px;" v-model="keywordData.o_salaryIdCard"></el-input>
        </el-form-item>
        <el-form-item label="日期参数">
          <el-input clearable size="mini" style="width:320px;" v-model="keywordData.o_salaryDate"></el-input>
        </el-form-item>
        <el-form-item :label="'第'+(i+1)+'列表头'" v-for="(x,i) in keywordData.o_salaryConfig" :key="i">
          <el-input clearable size="mini" style="width:320px;" v-model="keywordData.o_salaryConfig[i]"></el-input>
        </el-form-item>
      </el-form>
      <!-- 足部 -->
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="addRowHandler">新增列</el-button>
        <el-button type="primary" @click="keywordSubmitHandler">确 定</el-button>
        <el-button @click="keywordData={o_salaryConfig:[]},isShowSetkeyword=false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
// import AreaPicker from '@/components/AreaPicker_3'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation },
  data() {
    return {
      sign: 'gongzi',
      dialogTitle: '工资信息',
      fileName: '',
      importTipKey: 'u_idCard',
      importTiplabel: '员工身份证',

      baseInfo: [
        // { key: 'province', label: '省' },
        // { key: 'city', label: '市' },
        // { key: 'county', label: '县' },
        // { key: 'town', label: '镇' },
        // { key: 'village', label: '村' },

        // { key: 'aab004', label: '单位名称', fixed: true },
        // { key: 'aab022', label: '所属行业' },
        { key: 'idCard', label: '身份证' },
        { key: 'date', label: '日期' },
      ],

      isShowSetkeyword: false,
      keywordData: {
        o_salaryConfig: [],
      },
      tableHeads: [],
    }
  },
  computed: {
    importAction() {
      // return this.$api.baseUrl + '/user/salary/import'
      return this.$api.baseUrl + this.$api.url_import(this.sign)
    },
    formItems() {
      return [
        // { type: 'text', key: 'aab004', label: '单位名称' },
      ]
    },
    formItems2() {
      return null
    },
  },
  methods: {
    searchHandler() {
      console.log(`%cthis.filterForm:`, 'color: #00f;', this.filterForm)
      let rD = {}
      let keys = Object.keys(this.filterForm)
      if (keys.length > 0) {
        keys.forEach(x => {
          switch (typeof this.filterForm[x]) {
            case 'string':
            case 'number':
              this.filterForm[x] !== '' ? rD[x] = this.filterForm[x] : ''
              break;
            case 'object':
              for (const key in this.filterForm[x]) {
                // console.log(key)
                if (this.filterForm[x].hasOwnProperty(key)) {
                  const value = this.filterForm[x][key]
                  // console.log(value)
                  if (value) {
                    rD[x] = {}
                    rD[x][key] = this.filterForm[x][key]
                  }
                }
              }
              break;
          }
        })
      }
      rD.pageNumber = this.pageData.currentPage
      this.getData(rD)
    },
    // 打开配置对话框
    setKeywordHandler() {
      this.isShowSetkeyword = true
      let { o_salaryIdCard, o_salaryDate, o_salaryConfig } = this.userInfo
      this.keywordData = { o_salaryIdCard, o_salaryDate, o_salaryConfig }
    },
    // 增加一行
    addRowHandler() {
      this.keywordData.o_salaryConfig.push('')
    },
    // 提交配置
    keywordSubmitHandler() {
      let { id } = this.userInfo
      let { o_salaryIdCard, o_salaryDate, o_salaryConfig } = this.keywordData
      let rD = {
        id,
        o_salaryIdCard,
        o_salaryDate,
      }
      rD.o_salaryConfig = o_salaryConfig.filter(x => x)
      console.log(`%crD:`, 'color: #00f;', rD)
      this.$api._user_modify(rD).then(res => {
        if (res.data.status == 0) {
          this.$message.success('配置成功！')
          this.isShowSetkeyword = false
          this.$api.get_user_login_info().then(res => {
            if (res.data.status == 0) {
              let _R = JSON.parse(res.data.data)
              localStorage.setItem('loginData', res.data.data)
              this.userInfo.o_salaryIdCard = rD.o_salaryIdCard
              this.userInfo.o_salaryDate = rD.o_salaryDate
              this.userInfo.o_salaryConfig = rD.o_salaryConfig
            } else { this._status(res.data) }
          })
        } else { this._status(res.data) }
      })
    },

    
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      // console.log(result, this.selectData)
      let obj = {}
      this.tableHeads.forEach(x => {
        obj[x] = result[x]
      })
      let rData = {
        data: JSON.stringify(obj)
      }
      
      if (this.isCreate) {
        console.log(rData)
        
        // this.$api.util_create(this.sign, rData).then(res => {
        //   if (res.data.status == 0) {
        //     this.$message.success('新建成功')
        //     this.$refs.DialogEdit.isShowDialog = false
        //     this.$refs.DialogEdit.clearHandler()
        //     this.searchHandler()
        //   } else { this._status(res.data) }
        // })
      }

      else {
        rData.id = this.selectData.id // 绑定修改的数据id
        console.log(rData)
        
        this.$api.util_modify(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.getData()
          } else { this._status(res.data) }
        })
      }
    },
    getData(rD = {}) {
      if (this.userInfo.organization) {
        rD.o_name = this.userInfo.o_name
      } else if (this.userInfo.personal) {
        rD.u_idCard = this.userInfo.u_idCard
      }
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          this.tableHeads = [] // 存储用户自己设置的表头
          this.tableData = _R.map(x => {
            x.data_ = JSON.parse(x.data)
            Object.assign(x, x.data_)
            this.tableHeads = [...new Set([...this.tableHeads, ...Object.keys(x.data_)])]
            return x
          }) // 得到真实数据 并存储表头名称去重
          
          if (this.tableHeads.length) {
            this.baseInfo = [] // 先清空
            this.tableHeads.forEach(x => {
              this.baseInfo.push({
                key: 'data_.'+x,
                label: x,
              })
              this.formItems.push({
                type: 'text',
                key: x,
                label: x,
              })
            }) // 感觉处理得到的表头数组，动态设置表头
          } else {
            this.baseInfo = [
              { key: 'idCard', label: '身份证' },
              { key: 'date', label: '日期' },
            ]
          }
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    // const powerList = this.userInfo.privilegesList
    // const powerStr = powerMap[this.sign]
    const mapList1 = ['search','create','modify','delete','import','export']
    mapList1.forEach(x => {
      this.btnShow[x] = true
    })
    // const mapList = ['export']
    // if (this.userInfo.admin) {
    //   mapList.forEach(x => {
    //     this.btnShow[x] = true
    //   })
    // } else {
    //   mapList.forEach(x => {
    //     if (powerList.includes(powerStr + '-' + x)) {
    //       this.btnShow[x] = true
    //     }
    //   })
    // }

    this.getData()
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}
</style>